import React, { useState } from "react";
import { payrollTabs } from "../PayroleMocks";
import GymOverview from "./GymOverview";
import Overview from "./Overview";
import EmployeePayrollTable from "./EmployeePayrollTable";
import Discrepancies from "./Discrepancies";
import BulkProcess from "./BulkProcess";
import BankFiles from "./BankFiles";
import History from "./History";
import ProcessingFlow from "./ProcessingFlow";

const PayroleTabs = ({ userInfoData }) => {
  const isStaff =
    userInfoData?.account_type === "receptionist" ||
    userInfoData?.account_type === "trainer";

  const [activeTab, setActiveTab] = useState(
    isStaff ? "employees" : payrollTabs[0].value
  );

  return (
    <>
      {!isStaff && (
        <div className="lms-v2-tabs-container payrole-tabs-container mt15">
          {payrollTabs.map((tab, idx) => (
            <div
              key={idx}
              className={`lms-v2-tab${
                activeTab === tab.value ? " lms-v2-tab-active" : ""
              }`}
              onClick={() => setActiveTab(tab.value)}
              style={{ cursor: "pointer" }}
            >
              {tab.icon}

              <span>{tab.label}</span>
            </div>
          ))}
        </div>
      )}

      {activeTab === "gym-overview" && (
        <GymOverview userInfoData={userInfoData} />
      )}
      {activeTab === "overview" && <Overview userInfoData={userInfoData} />}
      {(activeTab === "employees" || isStaff) && (
        <EmployeePayrollTable userInfoData={userInfoData} />
      )}
      {activeTab === "discrepancies" && (
        <Discrepancies userInfoData={userInfoData} />
      )}
      {activeTab === "processing-flow" && (
        <ProcessingFlow userInfoData={userInfoData} />
      )}
      {activeTab === "bulk-process" && (
        <BulkProcess userInfoData={userInfoData} />
      )}
      {activeTab === "bank-files" && <BankFiles userInfoData={userInfoData} />}
      {activeTab === "history" && <History userInfoData={userInfoData} />}
    </>
  );
};

export default PayroleTabs;
